import { render, staticRenderFns } from "./WeChatInfo.vue?vue&type=template&id=4bdafd74&scoped=true"
import script from "./WeChatInfo.vue?vue&type=script&lang=js"
export * from "./WeChatInfo.vue?vue&type=script&lang=js"
import style0 from "./WeChatInfo.vue?vue&type=style&index=0&id=4bdafd74&prod&lang=scss&scoped=true"
import style1 from "./WeChatInfo.vue?vue&type=style&index=1&id=4bdafd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdafd74",
  null
  
)

export default component.exports